<div class="row">
    <div class="col">
        <ngx-loading [show]="loadingIndicator2"></ngx-loading>
        <!--<ngx-loading [show]="loadingIndicator"></ngx-loading>-->
        <div class="row">
            <div class="col-md-12">
                <h3 *ngIf="connote.control_no" class="d-flex align-items-center">
                    Connote Details - {{connote.control_no}} 
                    <span *ngIf="transvirtual_info != null" class="d-flex align-items-center pl-1" 
                          placement="bottom" ngbTooltip="{{transvirtualTooltip()}}">
                        <img [ngClass]="{'img-greyscale': transvirtualStatus() == 2, 'img-warningfail': transvirtualStatus() == 3}"
                             src="https://dev1-ceres.s3.ap-southeast-2.amazonaws.com/public/images/transvirtual/transvirtual-logo.png" width="18" height="18"/> &nbsp;
                    </span>
                    <span class="ml-2" style="font-size:14px" *ngIf="connote.run_status_id == 1" title="Edit" [routerLink]="['/bookings/edit', connoteId]">
                        <i class="fa fa-fw fa-pencil"></i>
                    </span>
                </h3> 
            </div>
        </div>
        <br />
        <div class="row" *ngIf="connote.control_no">
            <div class="col-md-4">
                <div widget class="card border-0 box-shadow">
                    <div class="card-header transparent border-0 text-muted">
                        <ng-container *ngIf="connote.run_type_id != 3">
                            <h5 class="mb-0">
                                <span [ngClass]="{'font-italic': connote.customer_deleted_date != null}">{{ connote.customer }}</span>
                                    <small><a href="javascript:void(0);" placement="bottom" ngbTooltip="Edit Customer Details" 
                                        (click)="openModalCustomer()">&nbsp;<i class="mx-1 fa fa-pencil"></i></a></small>
                                    </h5>
                                    <div class="mt-0 mb-2">
                                        {{connote.customer_address}}<br>
                                        <span><strong>Customer Reference #:</strong> {{connote.customer_reference_no}}</span>
                                    </div>
                            </ng-container>
                        <br/>
                        <span><strong>Job Type:</strong> {{connote.run_type}}</span>
                        <span *ngIf="connote.run_type_id == '2' && connote.linehaul_type_alias == 'ftl'">, Full Truckload</span>
                        <span *ngIf="connote.run_type_id == '2' && connote.linehaul_type_alias == 'ltl'">, Less-than TruckLoad</span>
                        <br />
                        <span>
                            <strong>Service Type:</strong> 
                            <ng-container *ngIf="connote.linehaul_type_alias != 'ltl';else isLTL">
                                {{connote.service_type}}
                            </ng-container>
                            <ng-template #isLTL>
                                None
                            </ng-template>
                        </span>
                        <div class="mt-0"><strong>Booked by:</strong> {{connote.booked_by}}</div>
                        <!--   <span>
                            <b>Dispatched by:</b> <br />
                            <b>Date of Manifest:</b> <br />
                            <span *ngIf="runData.departure_date && runData.departure_time; else departureEmpty">
                                <b>Departure Datetime:</b> 
                            </span>
                            <ng-template #departureEmpty>
                                <b>Departure Datetime:</b> No Departure Record Available.
                            </ng-template><br />
                            <span *ngIf="runData.arrival_date && runData.arrival_time; else arrivalEmpty">
                                <b>Arrival Datetime:</b> 
                            </span>
                            <ng-template #arrivalEmpty>
                                <b>Arrival Datetime:</b> No Arrival Record Available.
                            </ng-template>
                        </span>  
                        -->
                        <br *ngIf="!is_empty_run" />
                        <span *ngIf="!is_empty_run"><strong>Invoice Status:</strong> {{ invoice_status }} <br /></span>
                        <a class="secondary-link"
                            *ngIf="connote.run_status_id=='4' && invoice_status != 'Invoiced' && is_invoice_ready && !is_empty_run"
                            [routerLink]="['/invoices', 'create', '[' + connote.id + ']']"><br /><button type="button" class="btn btn-primary">Compose Invoice</button></a>
                        <a [routerLink]=""
                            *ngIf="connote.run_status_id=='4' && invoice_status !== 'Invoiced' && !is_invoice_ready && !is_empty_run"
                            (click)="openModalMarkForInvoice(connote.id)">
                            <i class="fa fa-lg fa-check-square-o text-danger"></i> Mark for Invoicing</a>
                        <ngx-loading [show]="loadingIndicator2"></ngx-loading>

                        <br /><br>
                        <div *ngIf="connote.run_status_id == '1'" 
                            class="alert alert-gray fade show" role="alert">
                            <strong>Pending</strong><br /> <small>Job was put on hold and still pending for re-dispatch.</small>
                        </div>
                        <div *ngIf="connote.run_status_id == '2'"
                            class="alert alert-info alert-dismissible fade show" role="alert">
                            <strong>Dispatched</strong><br /> <small>Job has been dispatched.</small>
                        </div>
                        <div *ngIf="connote.run_status_id == '3'"
                            class="alert alert-primary alert-dismissible fade show" role="alert">
                            <strong>Processing</strong><br /> <small>Job has been started and is now processing.</small>
                        </div>
                        <div *ngIf="connote.run_status_id == '4'"
                            class="alert alert-success alert-dismissible fade show" role="alert">
                            <strong>Completed</strong><br /> <small>Job has finished all activities and is now completed.</small>
                        </div>
                        <div *ngIf="connote.run_status_id == '5'" 
                            class="alert alert-danger alert-dismissible fade show" role="alert">
                            <strong>Cancelled</strong><br /> <small>Job has been cancelled.</small>
                        </div>
                        <div *ngIf="connote.run_status_id == '6'" 
                            class="alert alert-info alert-dismissible fade show" role="alert">
                            <strong>Withdrawn</strong><br /> <small>Job has been withdrawn.</small>
                        </div>
                        <div *ngIf="connote.run_status_id == '7'"
                            class="alert alert-info alert-dismissible fade show" role="alert">
                            <strong>Subcontracted</strong><br /> <small>Job has been assigned and Subcontracted.</small>
                        </div>
                        <div *ngIf="connote.run_status_id == '8'" 
                            class="alert alert-gray alert-dismissible fade show" role="alert">
                            <strong>Draft</strong><br /> <small>Job is a draft.</small>
                        </div>

                        <!--
                        <div>
                            <ng-container *ngFor="let type of run_types">
                                <span *ngIf="type.id == runData.run_type_id"><b>Run Type:</b> {{ type.label }}</span>
                            </ng-container> <br />
                            <ng-container *ngFor="let service of service_types">
                                <span *ngIf="service.id == runData.service_type_id"><b>Service Type:</b> {{ service.name }}</span>
                            </ng-container> <br />
                            <span *ngIf="runData.linehaul_type == 0"><b>Linehaul Type:</b> N/A</span><br />
                            <span><b>Total Driving Hours</b>: {{runData.total_driving_hours}} Hrs</span><br>
                            <span><b>TotalKlms</b>: {{runData.total_klms}} Klms</span><br>

                        </div>-->
                    </div>
                </div>

                <div widget class="card border-0 box-shadow mt-4" *ngIf="drivers.length > 0 || equipments.length > 0">
                    <div class="card-header transparent border-0 text-muted">
                        <span *ngIf="drivers.length > 0 && drivers[0].name">
                            <h6>Booked Driver{{drivers.length>1 ? 's' : ''}}:</h6>
                            <div class="row pt-1">
                                <ng-container *ngFor="let driver of drivers; let i = index">
                                    <div class="col-md-6">
                                        <b><i class="fa fa-user-circle-o" aria-hidden="true"></i>
                                            {{driver.name}}<br /></b>
                                        <span class="pl-4" *ngIf="driver.mobile_no"><i>({{driver.mobile_no}})</i></span>
                                    </div><br>
                                </ng-container>
                            </div><br>
                        </span>
                        <span *ngIf="equipments.length > 0">
                            <h6>Booked Equipment:</h6><br />
                            <div class="row">
                                <ng-container *ngFor="let fleet of equipments; let i = index">
                                    <div class="col-md-4">
                                        <small class="d-block mb-0" *ngIf="fleet.fleet_type_id == 1">UTE</small>
                                        <small class="d-block mb-0" *ngIf="fleet.fleet_type_id == 2">Rigid</small>
                                        <small class="d-block mb-0" *ngIf="fleet.fleet_type_id == 3">Prime Mover</small>
                                        <small class="d-block mb-0" *ngIf="fleet.fleet_type_id == 4">Trailer</small>
                                        <small class="d-block mb-0" *ngIf="fleet.fleet_type_id == 5">Dolly</small>

                                        <img *ngIf="fleet.fleet_subtype_id !=4 && fleet.fleet_subtype_id !=5" width="90"
                                            height="50" src="assets/img/dispatch/truck_img_sample.png">
                                        <img *ngIf="fleet.fleet_subtype_id == 4" width="90" height="50"
                                            src="assets/img/dispatch/trailerA_img_sample.png">
                                        <img *ngIf="fleet.fleet_subtype_id == 5" width="90" height="50"
                                            src="assets/img/dispatch/trailerB_img_sample.png">

                                        <p class="pt-2">{{fleet.rego}}</p>
                                        <p class="badge badge-danger badge-pill p-1" *ngIf="fleet.deleted_date != null">Decommissioned</p>

                                    </div><br>
                                </ng-container>
                            </div>
                        </span>

                    </div>
                </div>

                <div widget class="card border-0 box-shadow mt-4">
                    <div class="card-header border-0 text-muted">
                        <h6 class="mb-0">Tracking Details</h6>
                    </div>
                    <div class="card-body widget-body">
                        <!-- <div *ngFor="let j of jobHistory | orderBy: order; let i = index">
                            <p class="fs-13 text-gray" *ngIf="j.date">
                                <span class="badge badge-pill badge-info">{{ j.date }}</span>
                                &nbsp;&nbsp; {{j.text}}
                                <br />
                            </p>
                        </div> -->

                        <div *ngIf="history.length == 0; else historyList">
                            <span><i>No record of activities yet.</i></span>
                        </div>
                        <ng-template #historyList>
                            <ng-container
                                *ngFor="let list of history.slice()?.reverse(); let lastItem = last; let firstItem = first">

                                <ng-container *ngIf="list?.control_no == null || list?.control_no == connote.control_no">   
                                    <div class="row">
                                        <div class="col">
                                            <div class="container1">
                                                <!-- Left vertical line -->
                                                <div *ngIf="!lastItem" class="container1__line"></div>
    
                                                <!-- The timeline items container -->
                                                <ul class="container1__items">
                                                    <li class="container1__item">
                                                        <div class="container1__top"
                                                            [ngClass]="firstItem ? 'royalblue-color': 'text-muted'">
                                                            <!-- Circle -->
                                                            <div
                                                                [ngClass]="firstItem ? 'container1__circle_active': 'container1__circle_past'">
                                                            </div>
    
                                                            <!-- Title -->
                                                            <div class="container1__title ml-2">
                                                                <h6 class="d-inline fs-12">{{list.date | date:'dd MMM yyyy'}}, </h6>
                                                                <h6 class="d-inline fs-12">
                                                                    {{list.date | date:'h:mm a'}}
                                                                </h6>
                                                            </div>
                                                        </div>
    
                                                        <!-- Description -->
                                                        <div class="container1__desc">
                                                            <p class="mb-0 fs-12 text-muted">
                                                                {{list.user | titlecase}}
    
                                                                <!-- Book -->
                                                                <ng-container *ngIf="list.action=='book'"> booked {{list.connote_control_no}}</ng-container>
    
                                                                <!-- Local Start -->
                                                                <ng-container *ngIf="list.action=='start'">
                                                                    is preparing to ship 
                                                                    <a class="secondary-link" 
                                                                        title="Go to Manifest Details page"
                                                                        (click)="viewDispatch(list.run_id)">
                                                                        {{ list.manifest_control_no }}
                                                                    </a>
                                                                    at 
                                                                </ng-container>
    
                                                                <!-- Pickup -->
                                                                <ng-container *ngIf="list.action=='pickup' "> 
                                                                    picked up a freight from
                                                                    <a class="secondary-link" 
                                                                        title="Go to Manifest Details page"
                                                                        (click)="viewDispatch(list.run_id)">
                                                                        {{ list.manifest_control_no }}
                                                                    </a>
                                                                    at 
                                                                </ng-container>

                                                                <!-- Delivery -->
                                                                <ng-container *ngIf="list.action=='deliver'">
                                                                    delivered a freight from
                                                                    <a class="secondary-link" 
                                                                        title="Go to Manifest Details page"
                                                                        (click)="viewDispatch(list.run_id)">
                                                                        {{ list.manifest_control_no }}
                                                                    </a>
                                                                    at 
                                                                </ng-container>
    
                                                                <!-- Empty Run Start -->
                                                                <ng-container *ngIf="list.action=='empty run start'"> 
                                                                    departed with
                                                                    <a class="secondary-link" 
                                                                        title="Go to Manifest Details page"
                                                                        (click)="viewDispatch(list.run_id)">
                                                                        {{ list.manifest_control_no }}
                                                                    </a>
                                                                    at 
                                                                </ng-container>
    
                                                                <!-- Empty Run End -->
                                                                <ng-container *ngIf="list.action=='empty run end'">
                                                                    arrived with
                                                                    <a class="secondary-link" 
                                                                        title="Go to Manifest Details page"
                                                                        (click)="viewDispatch(list.run_id)">
                                                                        {{ list.manifest_control_no }}
                                                                    </a>
                                                                    at 
                                                                </ng-container>
    
    
                                                                <!-- Add Release -->
                                                                <ng-container *ngIf="list.action == 'add release'">
                                                                    returned {{list.connote_control_no}} to 
                                                                </ng-container>

                                                                <!-- Trailer Release -->
                                                                <ng-container *ngIf="list.action == 'trailer release'">
                                                                    released it from 
                                                                    <a class="secondary-link" 
                                                                        title="Go to Manifest Details page"
                                                                        (click)="viewDispatch(list.run_id)">
                                                                        {{ list.manifest_control_no }}
                                                                    </a>
                                                                    at 
                                                                </ng-container>

                                                                <!-- Trailer Collect -->
                                                                <ng-container *ngIf="list.action == 'trailer collect'">
                                                                    collected it from 
                                                                    <a class="secondary-link" 
                                                                        title="Go to Manifest Details page"
                                                                        (click)="viewDispatch(list.run_id)">
                                                                        {{ list.manifest_control_no }}
                                                                    </a>
                                                                    at 
                                                                </ng-container>

                                                                <!-- Location -->
                                                                <ng-container
                                                                    *ngIf="list.location == '    ' || list.location == '  ' || list.location == '   ' || list.location == null || list.action == 'add release'; else withLocation">
                                                                    <ng-container *ngIf="list.action == 'dispatch' || list.action == 'accept' || (list.action == 'end' && dispatch.run_type == 'Local');else noLocation"></ng-container>
                                                                    <ng-template #noLocation>
                                                                        the station
                                                                    </ng-template>
    
                                                                </ng-container>
                                                                <ng-template #withLocation>
                                                                    {{list.location}}
                                                                </ng-template>

                                                                <ng-container *ngIf="list.duration_minutes != null">
                                                                    <br/>
                                                                    <strong class="text-success">{{list.date | date:'dd MMM yyyy h:mm a'}} - {{list.date_end | date:'dd MMM yyyy h:mm a'}} <i class="text-primary">[{{list.duration_minutes}} <span *ngIf="list.duration_minutes <= 1">minute</span> <span *ngIf="list.duration_minutes > 1">minutes</span>]</i></strong>
                                                                    <br/>
                                                                    <span *ngIf="list.duration_minutes > getDemurrageCeiling(list.run_service_category_name)" class="text-warning">{{calculateDemurrageTime(list.duration_minutes, list.run_service_category_name)}}</span>
                                                                </ng-container>
                                                            </p>
                                                        </div>
                                                    </li>
    
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                            </ng-container>
                        </ng-template>


                    </div>
                </div>

            </div>
            <!--- END OF COLUMN 1-->

            <!--- START OF COLUMN 2-->
            <div class="col-md-4">
                <ng-container *ngIf="connote.customer">
                    <div class="card border-0 box-shadow" >
                        <div class="card-header border-0 text-muted">
                            <a href="javascript:void(0);" (click)="openModalRate(connote)"  class="float-left">
                                <i class="mx-1 fa fa-pencil"></i>
                            </a>
                            <h6 class="mb-0">Total Cost: ${{ getTotalCost() }} <small
                                    style="color:red"><strong>(EX. GST)</strong></small></h6>
                        </div>
                        <div class="card-body">
    <!--                    <div *ngIf="chargingMethodID == 2 || chargingMethodID == 3">
                                <b *ngIf="jobItems.length > 0">Items:<br /></b>
                                <div *ngIf="jobItems.length > 0">
                                    <code *ngFor="let j of jobItems" class="tab">
                                        {{j.quantity}} units of {{j.length}}cmx{{j.width}}cmx{{j.height}}cm, {{j.weight}}kg<br />
                                    </code>
                                </div>
    
                                <code *ngIf="jobItems.length > 0">
                                    Total Quantity: {{totalQuantity}}, Total Weight: {{totalWeight}}kg<span *ngIf="totalWeight > 0">s</span>., 
                                    Total Volume: {{totalVolume}} cu.cms.<br /><br />
                                </code>
    
    
                            </div> 
    -->
    <!--                    <div *ngIf="chargingMethodID == 1">
                                No. of Tonnes: {{ tonne }} <br />
                            </div>
    -->                     
                            <div>
                                <strong>Charge By: </strong>
                                <span *ngIf="connote.charging_method != 'Pallets'">{{connote.charging_method}}</span><span *ngIf="connote.charging_method == 'Pallets'">Freight Packaging</span>
                            </div>

                            <div  *ngIf="connote.charging_method == 'Pallets' && (connote.pallet > 0 && connote.pallet !=null)">
                                <strong>Chargeable Pallets: </strong> {{connote.pallet | number:'1.2-2'}}
                            </div>
    
                            <div  *ngIf="connote.charging_method == 'Tonne' && (connote.tonnes > 0 && connote.tonnes !=null)">
                                <strong>Units in Tonnes: </strong> {{connote.tonnes | number:'1.2-2'}}
                            </div>
    
                            <div><strong>Price/Rate per Unit:</strong> {{ (connote.price && connote.price !== null &&
                                connote.price !== undefined) ? '$' + (connote.price | number:'1.2-2'): "TBA"}}
                                <!-- {{(connote.charging_method == 'Hourly' && connote.price !== undefined)? '/Hour': ''}} -->
                            </div>
    
                            <div>
                                <strong>Fuel Levy:</strong>
                                {{ (connote.fuel_levy && connote.fuel_levy !== undefined) ? (connote.fuel_levy | number:'1.2-2') : "0"}}%
                            </div>
    
                            <div>
                                <strong>Service Fee:</strong>
                                {{ (connote.service_fee && connote.service_fee !== undefined) ? (connote.service_fee | number:'1.2-2') : "0"}}%
                            </div>

                            <!-- <div class="mt-3">
                                <strong>Other Cost:</strong>
                                {{ (connote.other_cost && connote.other_cost !== undefined) ? '$' + (connote.other_cost | number:'1.2-2') : "$0.00"}}
                            </div> -->
    
                            <div>
                                <a href="javascript:void(0);" placement="right" ngbTooltip="{{other_cost_details}}"><small><i><strong>Other Cost:</strong>
                                {{ (connote.other_cost && connote.other_cost !== undefined) ? '$' + (connote.other_cost | number:'1.2-2') : "$0.00"}}</i></small></a>
                                <!-- <small class="font-italic">
                                    <div class="ml-3 mx-0" *ngFor="let item of addin_items">{{item.addin_label}}: ${{item.cost | number:'1.2-2'}}</div>
                                </small> -->
                            </div>
                            <!-- <div *ngIf="connote.charging_method == 'Hourly'">
                                <strong>Total Work Hours:</strong> {{connote.est_total_hours}} hr
                            </div><br /> -->
    
    
    
                        </div>
                    </div>

                    <div class="card border-0 box-shadow my-4" *ngIf="packagings?.length > 0">
                        <div class="card-header border-0 text-muted">
                            <h6 class="mb-0">Packaging Details</h6>
                        </div>
                        <div class="card-body pt-0 widget-body">
                            <div class="mt-3">
                                <span *ngFor="let p of packagings">
                                    {{p.quantity}}x <b>{{p.packaging_type_label}} </b> <span class="text-primary">[L{{p.length}} x W{{p.width}} x H{{p.height}}][{{p.weight}}kg]</span><br/>
                                </span>
                            </div>
                        </div>
                    </div>
               
                    <div class="card border-0 box-shadow my-4">
                        <div class="card-header border-0 text-muted">
                            <h6 class="mb-0">Booking Details</h6>
                        </div>
                        <div class="card-body pt-0 widget-body">
    
                            <div class="mt-2">
                                <span><strong>Freight:</strong> <span *ngIf="connote.charging_method != 'Pallets'">{{connote.charging_method}}</span><span *ngIf="connote.charging_method == 'Pallets'">Freight Packaging</span></span>
                                <span *ngIf="getUnits(connote.charging_method_id)"> x {{getUnits(connote.charging_method_id)}} </span>
    <!--                        <span *ngIf="dgGoods"> ,DG</span>
                                <span *ngIf="!dgGoods"> ,Non-DG</span> 
    -->
                                <br />
                                <span><strong>Service:</strong> {{connote.service_type}}</span>
                                <div class="mt-2 " *ngIf="connote.is_dg==1 && connote.dg_class">
                                    DG, {{connote.dg_type}}<br />
                                    {{connote.dg_class}}
                                    <span *ngIf="connote.dg_subsidiary_risks"><br />
                                        <small>
                                            Subsidiary risks:
                                            {{connote.dg_subsidiary_risks}}
                                        </small>
                                    </span>
                                    <br />
                                </div>
                            </div>
                            <div *ngFor="let s of sites; let i = index" class="mt-3">
                                <p class="fs-13 text-gray">
                                    <span class="badge badge-pill badge-success">{{ s.run_action}}</span>
                                    <span> 
                                        {{ (formatDate(s.opening_datetime) !== null) ? (formatDate(s.opening_datetime) | date: 'dd MMM yyyy, HH:mm') : " " }} to
                                        {{ (formatDate(s.closing_datetime) !== null) ? (formatDate(s.closing_datetime) | date: 'HH:mm') : " " }}
                                    </span>
                                    <br />
    <!--                            <a href="javascript:;" placement="bottom" ngbTooltip="Edit Site" class="mr-2" (click)="openModalEditPoints(p, i)">
    -->                             <i class="fa fa-truck" style='font-size:18px; color:#595959'></i>&nbsp;
    <!--                            </a> 
    -->
    <!--                            <a ngxClipboard href="javascript:;" placement="bottom" ngbTooltip="Copy to Clipboard"  [cbContent]="getCopy(p.address_full)"><i class="fa fa-copy"></i></a>&nbsp;
    --> 
    
                                    <span *ngIf="s.is_done"><i class="fa fa-check-square-o" style="font-size:18px; color:#595959" aria-hidden="true"></i>&nbsp;</span>
    
                                    
                                    <span container="body" *ngIf="s.lat != null && s.lng != null;else TBA_address">
                                        <span *ngIf="s.company_name!=null">{{s.company_name}}, </span>{{s.full_address}}</span>
                                    <ng-template #TBA_address>
                                        <span container="body">Location to be announced.</span>
                                    </ng-template>
                                    <br />
    <!--                            <span>{{p.location_type}} Site</span>
                                    <span *ngIf="p.is_tail_lift">, Tail-lift required</span>
                                    <span *ngIf="p.is_hand_unload">, Hand-unload required</span>
                                    <span *ngIf="p.is_trailer_split">, Trailer split</span>
    -->                             
                                    <a class="text-blue" (click)="editActivity(s, i);" placement="bottom" ngbTooltip="Edit Activity Details">
                                        <i class="fa fa-pencil"></i>&nbsp;
                                    </a>
                                    <span container="body">{{s.contact_name}}<span *ngIf="s.contact_name!=null && s.contact_no"> / </span>{{s.contact_no}}<span *ngIf="s.contact_email!=null"> / </span>{{s.contact_email}}</span><br>
                                    <span *ngIf="s.notes!=null" container="body">Notes: {{s.notes}}<br></span>
                                    <span *ngIf="s.business_open_time!=null || s.business_close_time!=null" container="body">Business hours: <i>Opening Time: </i> {{s.business_open_time}} <i>Closing Time: </i> {{s.business_close_time}}<br></span>
                                    <span *ngIf="s.premise_type_id !=null">Premise Type: <span *ngFor="let pt of premise_types"> <i *ngIf="pt.id == s.premise_type_id">{{pt.name}}</i></span></span><br/>
                                
                                    <span *ngIf="s.is_direct=='1'">&nbsp;<i class="fa fa-check-square-o"></i>&nbsp;Direct {{s.action}}</span>
                                    <span *ngIf="s.is_guaranteed=='1'">&nbsp;<i class="fa fa-check-square-o"></i>&nbsp;Guaranteed</span>
                                    <span *ngIf="s.is_extra_crew=='1'">&nbsp;<i class="fa fa-check-square-o"></i>&nbsp;Extra crew</span>
                                    <span *ngIf="s.is_hand_unload=='1'">&nbsp;<i class="fa fa-check-square-o"></i>&nbsp;Hand unload</span>
                                    <!-- <span *ngIf="s.is_residential=='1'">&nbsp;<i class="fa fa-check-square-o"></i>&nbsp;Residential</span> -->
                                    <span *ngIf="s.is_tailgate=='1'">&nbsp;<i class="fa fa-check-square-o"></i>&nbsp;Tailgate</span>
                                    <span *ngIf="s.is_trailer_split=='1'">&nbsp;<i class="fa fa-check-square-o"></i>&nbsp;Trailer split</span>
                                    <span *ngIf="s.is_atl=='1'">&nbsp;<i class="fa fa-check-square-o"></i>&nbsp;Authority to Leave</span>
                                    <span *ngIf="s.is_tail_lift=='1'">&nbsp;<i class="fa fa-check-square-o"></i>&nbsp;Tail Lift</span>
                                </p>
                            </div>
    
    
    
                        </div>
                    </div> <!-- END BOOKING DETAILS WINDOW-->
                </ng-container>

                <div class="card border-0 box-shadow">
                    <div class="card-header border-0 text-muted">
                        <ul class="nav nav-tabs card-header-tabs" id="documentsTab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="document-tab" data-toggle="tab" href="#documents" role="tab" aria-controls="documents" aria-selected="true">Documents</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="compliance-tab" data-toggle="tab" href="#compliance" role="tab" aria-controls="compliance" aria-selected="false">Compliance</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="uploads-tab" data-toggle="tab" href="#uploads" role="tab" aria-controls="uploads" aria-selected="false">Uploads</a>
                            </li>
                        </ul>
                    </div>

                    <div class="card-body p-0">
                        <div class="tab-content border-0" id="documentsTabContent">
                            <div class="tab-pane show active" id="documents" role="tabpanel" aria-labelledby="document-tab">
                                <small>
                                    <ul class="list-group" *ngFor="let d of documents, let i = index">
                                        <li class="list-group-item" *ngIf="d.user_id == null && d.driver_id == null">
                                            {{d.type}}:&nbsp;
                                            <a href="{{url.cloudStorage}}/{{d.folder}}/{{d.file}}" target="_blank">{{d.file}}</a>&nbsp; 
                                            <i *ngIf="d.type_id == 9" class="btn-link fa fa-refresh fa-spin" style="font-size:15px"
                                                data-toggle="tooltip" title="Generate New Connote File" aria-hidden="true" (click)="openGenerateDocument(d.type)" ></i>&nbsp;
                                            <i *ngIf="d.type_id == 12" class="btn-link fa fa-refresh fa-spin" style="font-size:15px"
                                                data-toggle="tooltip" title="Generate New PPD" aria-hidden="true" (click)="openGenerateDocument(d.type)"></i>    
                                            <i *ngIf="d.type_id == 15" class="btn-link fa fa-refresh fa-spin" style="font-size:15px"
                                            data-toggle="tooltip" title="Generate New Packaging Label" aria-hidden="true" (click)="openGenerateDocument(d.type)"></i>
                                        </li>
                                    </ul>
                                    <span *ngIf="documents.length === 0" class="text-center">No documents currently available</span>
                                </small>
                            </div>
                            
                            <div class="tab-pane" id="compliance" role="tabpanel" aria-labelledby="compliance-tab">
                                <small>
                                    <div *ngIf="driverTests[0]">
                                        <span><b>Driver Tests</b><br /></span>
                                        <span *ngFor="let dt of driverTests, let i = index"><a
                                                href="{{url.cloudStorage}}/compliance/{{dt.file}}"
                                                target="_blank">{{dt.file}}</a><br />
                                        </span>
                                    </div>
                                    <div *ngIf="vehicleTests[0]"><br />
                                        <span><b>Equipment Checks</b><br /></span>
                                        <span *ngFor="let tt of vehicleTests, let i = index"><a
                                                href="{{url.cloudStorage}}/compliance/{{tt.file}}"
                                                target="_blank">{{tt.file}}</a><br />
                                        </span>
                                    </div>
        
                                </small>
                            </div>
        
                            <div class="tab-pane" id="uploads" role="tabpanel" aria-labelledby="uploads-tab">
                                <ng-container>
                                    <small>
                                        <span *ngFor="let notif of job_notifications">
                                            <span *ngIf="notif.activity_type_id == 20">
                                                <i><b>{{notif.created_at | date:'dd/MM/yyyy HH:mm'}} - {{notif.text}} </b> </i><br>
                                            </span>
                                        </span>
                                        <span *ngIf="has_admin_upload">
                                            <span><b>ADMIN UPLOAD: <br></b></span>
                                            <span *ngFor="let doc of documents">
                                                <span *ngIf="doc.role == 'Administrator' || doc.role == 'Super Administrator'">
                                                    <a (click)="openDeleteFile(doc)" href="javascript:void(0);" title="Delete File" class="transition" style="font-size: medium;">
                                                        <i class="fa fa-trash"></i>
                                                    </a>&nbsp;
                                                    <i>{{doc.type}}: </i>
                                                    <a href="{{url.cloudStorage}}/{{doc.folder}}/{{doc.file}}" target="_blank" style="word-wrap: break-word;">{{doc.file}}</a><br>
                                                </span>
                                            </span>
                                        </span>
                                        <br *ngIf="has_driver_upload">
                                        <span *ngIf="has_driver_upload">
                                            <span><b>DRIVER UPLOAD: <br></b></span>
                                            <span *ngFor="let doc of documents">
                                                <span *ngIf="doc.role == 'Driver'">
                                                    <a (click)="openDeleteFile(doc)" href="javascript:void(0);" title="Delete File" class="transition" style="font-size: medium;">
                                                        <i class="fa fa-trash"></i>
                                                    </a>&nbsp;
                                                    <i>{{doc.title}}: </i>
                                                    <a href="{{url.cloudStorage}}/{{doc.folder}}/{{doc.file}}" target="_blank">{{doc.file}}</a><br>
                                                </span>
                                            </span>
                                        </span>
                                        <br *ngIf="has_customer_upload">
                                        <span *ngIf="has_customer_upload">
                                            <span><b>CUSTOMER UPLOAD: <br></b></span>
                                            <span *ngFor="let doc of documents">
                                                <span *ngIf="doc.role == 'Customer'">
                                                    <a (click)="openDeleteFile(doc)" href="javascript:void(0);" title="Delete File" class="transition" style="font-size: medium;">
                                                        <i class="fa fa-trash"></i>
                                                    </a>&nbsp;
                                                    <i>{{doc.type}}: </i>
                                                    <a href="{{url.cloudStorage}}/{{doc.folder}}/{{doc.file}}" target="_blank">{{doc.file}}</a><br>
                                                </span>
                                            </span>
                                        </span>
        
                                        <span><br/>
                                            <a href="javascript:void(0);" (click)="openModalAddFile()">
                                                <span class="badge badge-pill badge-success text-primary ml-1">
                                                    <i class="fa fa-plus"></i>
                                                </span> &nbsp;Add File
                                            </a>&nbsp;&nbsp;
                                        </span><br/>
                                        <!-- <span *ngIf = "pod_app.length > 0 ">
                                                <span><b>DRIVER UPLOAD: <br></b></span>
                                                <span *ngFor = "let pod_app of pod_app">
                                                    <a (click)="openDeleteFile(pod_app)" href="javascript:void(0);" title="Delete File" class="transition" style="font-size: medium;"><i class="fa fa-trash"></i></a>&nbsp;
                                                    <i>{{pod_app.title}}: </i>
                                                    <a href="{{url.cloudStorage}}/pod/{{pod_app.file}}" target="_blank">{{pod_app.file}}</a><br>
                                                </span>
                                            </span>
                                            
                                            <span *ngIf = "pod_tms.length > 0">
                                                <span><b>ADMIN UPLOAD: <br></b></span>
                                                <span *ngFor = "let pod_tms of pod_tms">
                                                    <a (click)="openDeleteFile(pod_tms)" href="javascript:void(0);" title="Delete File" class="transition" style="font-size: medium;"><i class="fa fa-trash"></i></a>&nbsp;
                                                    <i>{{pod_tms.title}}: </i>
                                                    <a href="{{url.cloudStorage}}/connote_admin_uploads/{{pod_tms.file}}" target="_blank">{{pod_tms.file}}</a><br>
                                                </span>
                                            </span>
        
                                            <span *ngIf = "loading_unloading.length > 0">
                                                <span><b>Loading and Unloading: <br></b></span>
                                                <span *ngFor = "let load of loading_unloading">
                                                    <a (click)="openDeleteFile(load)" href="javascript:void(0);" title="Delete File" class="transition" style="font-size: medium;"><i class="fa fa-trash"></i></a>&nbsp;
                                                    <i>{{load.title}}: </i>
                                                    <a href="{{url.cloudStorage}}/connote_admin_uploads/{{load.file}}" target="_blank">{{load.file}}</a><br>
                                                </span>
                                            </span>
        
                                            <span *ngIf = "diary.length > 0">
                                                <span><b>Diary<br></b></span>
                                                <span *ngFor = "let diary of diary">
                                                    <a (click)="openDeleteFile(diary)" href="javascript:void(0);" title="Delete File" class="transition" style="font-size: medium;"><i class="fa fa-trash"></i></a>&nbsp;
                                                    <i>{{diary.title}}: </i>
                                                    <a href="{{url.cloudStorage}}/connote_admin_uploads/{{diary.file}}" target="_blank">{{diary.file}}</a><br>
                                                </span>
                                            </span>
        
                                            <span *ngIf = "generated_diary.length > 0">
                                                <span><b>Generated Diary File: <br></b></span>
                                                <span *ngFor = "let generated_diary of generated_diary">
                                                    <a (click)="openDeleteFile(generated_diary)" href="javascript:void(0);" title="Delete File" class="transition" style="font-size: medium;"><i class="fa fa-trash"></i></a>&nbsp;
                                                    <i>{{generated_diary.title}}: </i>
                                                    <a href="{{url.cloudStorage}}/connote_admin_uploads/{{generated_diary.file}}" target="_blank">{{generated_diary.file}}</a><br>
                                                </span>
                                            </span>
        
                                            <span *ngIf = "generated_pod.length > 0">
                                                <span><b>Generated POD File: <br> </b></span>
                                                <span *ngFor = "let generated_pod of generated_pod">
                                                    <a (click)="openDeleteFile(generated_pod)" href="javascript:void(0);" title="Delete File" class="transition" style="font-size: medium;"><i class="fa fa-trash"></i></a>&nbsp;
                                                    <i>{{generated_pod.title}}: </i>
                                                    <a href="{{url.cloudStorage}}/connote_admin_uploads/{{generated_pod.file}}" target="_blank">{{generated_pod.file}}</a><br>
                                                </span>
                                            </span>
        
                                            <span *ngIf = "connote_file.length > 0">
                                                <span><b>Connote File: <br> </b></span>
                                                <span *ngFor = "let connote_file of connote_file">
                                                    <a (click)="openDeleteFile(connote_file)" href="javascript:void(0);" title="Delete File" class="transition" style="font-size: medium;"><i class="fa fa-trash"></i></a>&nbsp;
                                                    <i>{{connote_file.title}}: </i>
                                                    <a href="{{url.cloudStorage}}/connote_admin_uploads/{{connote_file.file}}" target="_blank">{{connote_file.file}}</a><br>
                                                </span>
                                            </span>
                                            
                                            <span *ngIf = "dg_file.length > 0">
                                                <span><b>DG File: <br> </b></span>
                                                <span *ngFor = "let dg_file of dg_file">
                                                    <a (click)="openDeleteFile(dg_file)" href="javascript:void(0);" title="Delete File" class="transition" style="font-size: medium;"><i class="fa fa-trash"></i></a>&nbsp;
                                                    <i>{{dg_file.title}}: </i>
                                                    <a href="{{url.cloudStorage}}/connote_admin_uploads/{{dg_file.file}}" target="_blank">{{dg_file.file}}</a><br>
                                                </span>
                                            </span>
        
                                            <span *ngIf = "documentation_file.length > 0">
                                                <span><b>Documentation File: <br> </b></span>
                                                <span *ngFor = "let documentation_file of documentation_file">
                                                    <a (click)="openDeleteFile(documentation_file)" href="javascript:void(0);" title="Delete File" class="transition" style="font-size: medium;"><i class="fa fa-trash"></i></a>&nbsp;
                                                    <i>{{documentation_file.title}}: </i>
                                                    <a href="{{url.cloudStorage}}/connote_admin_uploads/{{documentation_file.file}}" target="_blank">{{documentation_file.file}}</a><br>
                                                </span>
                                            </span>
        
                                            <span *ngIf = "ppd.length > 0">
                                                <span><b>PPD: <br> </b></span>
                                                <span *ngFor = "let ppd of ppd">
                                                    <a (click)="openDeleteFile(ppd)" href="javascript:void(0);" title="Delete File" class="transition" style="font-size: medium;"><i class="fa fa-trash"></i></a>&nbsp;
                                                    <i>{{ppd.title}}: </i>
                                                    <a href="{{url.cloudStorage}}/connote_admin_uploads/{{ppd.file}}" target="_blank">{{ppd.file}}</a><br>
                                                </span>
                                            </span>
        
                                            <span *ngIf = "runsheet.length > 0">
                                                <span><b>Runsheet: <br> </b></span>
                                                <span *ngFor = "let runsheet of runsheet">
                                                    <a (click)="openDeleteFile(runsheet)" href="javascript:void(0);" title="Delete File" class="transition" style="font-size: medium;"><i class="fa fa-trash"></i></a>&nbsp;
                                                    <i>{{runsheet.title}}: </i>
                                                    <a href="{{url.cloudStorage}}/connote_admin_uploads/{{runsheet.file}}" target="_blank">{{runsheet.file}}</a><br>
                                                </span>
                                            </span>
        
                                            <span><br/>
                                                <a href="javascript:void(0);" (click)="openModalAddFile()">
                                                    <span class="badge badge-pill badge-success text-primary ml-1">
                                                        <i class="fa fa-plus"></i>
                                                    </span> &nbsp;Add File
                                                </a>&nbsp;&nbsp;
                                            </span><br/>
                                            -->
                                    </small>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <br>
                <ng-container *ngIf="transvirtual_info != null">
                    <div class="card border-0 box-shadow" *ngIf="transvirtual_info['transvirtual_logs']?.length != 0">
                        <div class="card-header border-0 text-muted">
                            <h6 class="mb-0">Transvirtual Updates</h6>
                        </div>
    
                        <div class="card-body pt-0 widget-body">
                            <div class="mt-3 mb-2" style="max-height:150px;overflow-y:auto; overflow-x:hidden;">
                                <ng-container *ngFor="let log of transvirtual_info['transvirtual_logs'];">
                                    <div class="container1__title ml-2">  
                                        <span class="badge" [ngClass]="(log.status_code==200)? 'badge-success': 'badge-danger'">{{(log.status_code == 200)?'Success':'Failed'}}</span>
                                        <a (click)="openTransvirtualModal(log)"  onMouseOver="this.style.color='#009'" onMouseOut="this.style.color='#000'" >
                                            <h6 class="pl-2 d-inline fs-12 font-weight-bold"> {{log.request_type.description | titlecase}} </h6>
                                            <small class="d-inline font-italic">
                                                last update at {{log.updated_at | date:'dd MMM yyyy h:mm a'}}.
                                               {{(log.status_code !=200)?'(Attempts: ' + (log.retry_times + log.previous_logs?.length) + ')' : null}}
                                            </small>
                                        </a>
                                        <small>
                                            <button style="border:none; background-color: transparent;" (click)="logview = log; retryTransvirtualUpdate(log)" [hidden]="retryClicked || log.retry_times > 3">
                                                <i *ngIf="transvirtual_info.isActive && log.status_code !=200" class="btn-link fa fa-refresh" style="font-size:15px"
                                                data-toggle="tooltip" title="Retry" aria-hidden="true"></i>
                                            </button>
                                            <i class="fa fa-refresh fa-spin" *ngIf="retryClicked && log.id == logview?.id" ></i>&nbsp;
                                        </small>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <!--- END OF COLUMN 2-->

            <!--- START OF COLUMN 3-->
            <div class="col-md-4">
                <div widget class="card border-0 box-shadow mb-4" *ngIf="dispatch.control_no">
                    <div class="card-header border-0 text-muted">
                        <h6 class="mb-0">Manifest Details</h6>
                    </div>

                    <div class="card-body pt-0 widget-body">
                        <div class="mt-3">
                            <ng-container *ngFor="let dispatched of dispatches;let start=start ;let last=last">
                                <strong>Manifest Control #: </strong>
                                <a class="secondary-link" title="Go to Manifest Details Page"
                                    (click)="viewDispatch(dispatched.id)">
                                    {{dispatched.control_no}}
                                </a>

                                <!-- Swapped with -->
                                <div class="mt-1" *ngIf="dispatched.changeover_run_id != null">
                                    <strong>Changeover With #: </strong>
                                    <a class="secondary-link" title="Go to Manifest Details Page"
                                        (click)="viewDispatch(dispatched.changeover_run_id)">
                                        {{dispatched.changeover_control_no}}
                                    </a>
                                </div>

                                <div class="mt-1">
                                    <strong>Dispatched by:</strong> 
                                    <ng-container *ngFor="let dispatcher of dispatched.created_by_name; let lastDispatcher=last">
                                        {{dispatcher | titlecase}}<ng-container *ngIf="dispatched.created_by_name.length > 1 && !lastDispatcher">, </ng-container>
                                    </ng-container>
                                </div>

                                <div class="mt-3" *ngIf="dispatched.run_type_id != 1 || dispatched.run_type_id != 6">
                                    <strong>SDP: </strong>
                                    <ng-container *ngIf="dispatched.sdp_file != null;else noSDPFile">
                                        <a href="{{url.cloudStorage}}/sdp/{{dispatched.sdp_file}}" target="_blank">{{dispatched.sdp_file}}</a>
                                        <ng-container *ngIf="dispatched.changeover_sdp_file != null">
                                            <span>, </span>
                                            <a href="{{url.cloudStorage}}/sdp/{{dispatched.changeover_sdp_file}}" target="_blank">{{dispatched.changeover_sdp_file}}</a>
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #noSDPFile>
                                        --
                                    </ng-template>
                                </div>
                                <hr *ngIf="!last">

                            </ng-container>
                        </div>
                    </div>
                    <!--- END OF COLUMN 3-->
                </div>

                <div widget class="card border-0 box-shadow mb-4">
                    <div class="card-header border-0 text-muted">
                        <h6 class="mb-0">Special Instructions
                            <a class="float-right text-blue" (click)="sp_appear = true;">
                                <i class="fa fa-xs fa-pencil"></i>
                            </a>
                        </h6>
                    </div>
                    <div class="card-body alert-warning p-0 widget-body">
                        <div class="mt-3">
                            <div class="row" *ngIf="sp_appear">
                                <div class="col-12">
                                    <div class="col-md-12 mb-2 float-right">
                                        <small class="text-warning" *ngIf="connote['special_instructions'] == null || connote['special_instructions'] == '' ">There are no special instructions yet.</small>
                                        <textarea class="form-control form-control-sm" rows="3" [(ngModel)]="sp_instructions"></textarea><br/>
                                        <button class="btn btn-sm btn-success" (click)="updateSpecialInstructions()"> Save </button>&nbsp;
                                        <button class="btn btn-sm btn-gray" (click)="sp_appear = false" > Cancel </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="!sp_appear">
                                <div class="col-md-12 mb-2 float-right">
                                    <p class="mx-3" style="color:rgb(78, 69, 69);"><strong><i>{{connote.special_instructions}}</i> </strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div widget class="card border-0 box-shadow" >
                    <div class="card-header border-0 text-muted">
                        <h6 class="mb-0" 
                            *ngIf="connote.run_status_id == '1' || connote.run_status_id == '2' || connote.run_status_id == '3' || connote.run_status_id == '4'"> 
                            Notes
                            <a class="float-right text-blue" (click)="openModalNote(null)">
                                <i class="fa fa-xs fa-plus"></i>
                            </a>
                        </h6>
                    </div>
                    <div class="card-body alert-warning p-0 widget-body">
                        <ng-container *ngIf="!notes.length">
                            <div class="mb-0 py-3 alert alert-warning fade show" role="alert">
                                <small>There are no notes for this connote yet. <a href="javascript:void(0);"
                                        (click)="openModalNote(null)">Add Notes</a> now.</small>
                            </div>
                        </ng-container>

                        <div class="mt-3" *ngFor="let note of notes; let i = index; let last=last">
                            <div class="row">
                                <small class="col mx-3">
                                    <i>{{ (note.created_at !== null) ? (note.created_at | date: 'dd MMM yyyy h:mm a') : "No Date"}}</i>
                                </small>
                                <div class="col mx-3">
                                    <a href="javascript:void(0);" (click)="openModalDeleteNote(note)" class="float-right">
                                        <i class="mx-1 fa fa-trash"></i>
                                    </a>
                                    <a href="javascript:void(0);" (click)="openModalNote(note)" class="float-right">
                                        <i class="mx-1 fa fa-pencil"></i>
                                    </a>
                                </div>

                                <div class="col-md-12 mb-2 float-right">
                                    <p class="mx-3" style="color:rgb(78, 69, 69);">{{note.text}} </p>
                                </div>

                                <small class="col-md-12 mb-3" *ngIf="note.updated_by == null">
                                    <i class="mx-3">Created by: {{note.user}}</i>
                                </small>

                                <small class="col-md-12 mb-3" *ngIf="note.updated_by !== null">
                                    <i class="mx-3">Created by: {{note.user}} </i> <br>
                                    <i class="mx-3">Updated by: {{note.updated_by}} </i>
                                </small>
                            </div>
                            <hr class="my-0" *ngIf="!last">
                        </div>
                    </div>

                   
                    <!--- END OF COLUMN 3-->

                </div>
            </div>
        </div>
    </div>
</div>
<!-- START OF NOTE MODAL  -->
<ng-template #modalNote let-close="close">
    <div class="modal-header">
        <div class="col px-0" *ngIf="!isEditMode">
            <div class="row no-gutters pt-0">
                <span class="col-1"><i class="fa fa-2x fa-file-text-o" style="color:pink"></i></span>
                <div class="col" *ngIf="connote.control_no">
                    <h5 class="modal-title">Create New Note for {{connote.control_no}}</h5>
                </div>
            </div>
        </div>

        <div class="col px-0" *ngIf="isEditMode">
            <div class="row no-gutters pt-0">
                <span class="col-1"><i class="fa fa-2x fa-file-text-o" style="color:pink"></i></span>
                <div class="col">
                    <h5 class="modal-title">Edit Note</h5>
                </div>
            </div>
        </div>

        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>

    </div>

    <form [formGroup]="frmNote" novalidate (ngSubmit)="onSubmitNote(frmNote.value)">
        <div class="modal-body">
            <div class="row pt-0">
                <div class="col-md-12">
                    <textarea rows="5" style="width:100%; padding-left: 4px; padding-right: 4px;" cols="70" formControlName="text"  minlength="1" maxlength="1000"></textarea>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button *ngIf="!isEditMode" type="submit" class="btn btn-sm btn-success" [disabled]="!frmNote.valid"> Save </button>
            <button *ngIf="isEditMode" type="submit" class="btn btn-sm btn-success" [disabled]="!frmNote.valid"> Save Changes</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="close()"> Cancel</button>
        </div>
    </form>
</ng-template>
<!-- END OF NOTE MODAL  -->


<!-- START OF MODAL DELETE NOTE -->
<ng-template #modalDeleteNote let-close="close">
    <div class="modal-header">
        <div class="col px-0">
            <div class="row no-gutters pt-0">
                <span class="col-1"><i class="fa fa-2x fa-file-text-o" style="color:orange"></i></span>
                <div class="col ml-1">
                    <h5 class="modal-title">&nbsp;Delete Note</h5>
                </div>
            </div>
        </div>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
                <p class="mb-0">Do you really want to delete this note?</p> <br />
                <footer class="blockquote-footer" style="word-wrap: break-word;">{{note.text}}</footer>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onDeleteNote(note.id)">Delete</button>
        <button type="button" class="btn btn-secondary" (click)="close()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE NOTE -->

<!-- START OF ADD FILE FORM -->
<ng-template #modalAddFile let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Upload New File</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="frmJobFile" novalidate (ngSubmit)="onSubmitJobFile(frmJobFile.value)">
        <div class="modal-body">
            <div class="row">

                <div class="form-group col-md-12">
                    <label class="form-control-label">Description</label>
                    <input formControlName="description" class="form-control form-control-sm" type="text">
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-12">
                    <label class="form-control-label">File Type <span class="text-danger">*</span></label>
                    <select class="form-control form-control-sm" formControlName="connote_document_type_id" required>
                        <option value="1">POD</option>
                        <!-- <option value="2">SDP</option>
                        <option value="3">Customer SDP</option>
                        <option value="4">Tripsheet</option> -->
                        <option value="5">Loading and Unloading</option>
                        <option value="6">Diary File</option>
                        <option value="7">Generated Diary File</option>
                        <option value="8">Generated POD</option>
                        <option value="10">DG File</option>
                        <option value="11">Documentation File</option>
                        <option value="12">PPD</option>
                        <option value="13">Runsheet</option>
                    </select>
                    <div>
                        <div>
                            <small class="text-danger">This field is required.</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="text-gray">File <span class="text-danger">*</span></label>
                        <app-file-uploader (passFile)="getJobFile($event)"></app-file-uploader>
                        <small class="text-danger">This field is required.</small>
                    </div>
                    <small><i>*Note: Allowed files are *.pdf, image files (*png,*.jpg,*.gif).</i></small>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button type="submit" class="btn btn-sm btn-success">Save</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
        </div>
    </form>
</ng-template>
<!-- END OF ADD FILE MODAL -->


<!-- START OF DELETE FILE MODAL -->
<ng-template #modalDeleteFile let-close="close">
    <div class="modal-header">
        <div class="col px-0">
            <div class="row no-gutters pt-0">
                <span class="col-1"><i class="fa fa-2x fa-file-text-o" style="color:orange"></i></span>
                <div class="col">
                    <h5 class="modal-title">Delete File</h5>
                </div>
            </div>
        </div>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body bg-gray">
        <div class="row pt-0">
            <div class="col-md-12">
                <p class="mb-0">Do you really want to delete this file?</p> <br />
                <label>{{delete_id.file}}</label>
            </div>

        </div>


    </div>
    <div class="modal-footer"><i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger" (click)="deleteFile(delete_id)" [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
    </div>
</ng-template>
<!-- END OF DELETE FILE MODAL -->

<!-- START OF MODAL MARK JOB FOR INVOICING  -->
<ng-template #modalMarkJobForInvoicing let-close="close">
    <div class="modal-header">
        <div class="col px-0">
            <div class="row no-gutters pt-0">
                <span class="col-1"><i class="fa fa-2x fa-calendar-check-o" style="color:green"></i></span>
                <div class="col">
                    <h5 class="modal-title">Mark Job for Invoicing</h5>
                </div>
            </div>
        </div>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
                <b>Do you really want to mark this job for invoicing?</b> <br />
                <b>Customer:</b> {{connote.customer}} <br />
                <b>Job Control No.:</b> {{connote.control_no}} <br />
                <b>Date Done:</b>
                {{ (connote.arrival_date !== null) ? (connote.arrival_date | date: 'dd MMM yyyy') : "No Date" }}
                <br />
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-success" (click)="onMarkJobForInvoicing(currentId)">
            Accept</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()" ngbAutofocus>
            Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL MARK JOB FOR INVOICING  -->


<!-- START OF MODAL GENERATE DOCUMENT -->
<ng-template #modalGenerate let-close="close">
    <div class="modal-header">
        <div class="col px-0">
            <div class="row no-gutters pt-0">
                <span class="col-1"><i class="fa fa-2x fa-file-text-o" style="color:orange"></i></span>
                <div class="col ml-1"><h5 class="modal-title">&nbsp;Generate New {{document}}</h5></div>
            </div>
        </div>
       
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
                <p class="mb-0">Are you sure to regenerate new {{document}}? This will overwrite the current {{document}}.</p> <br />
                <p><i>Note: Kindly download current file before doing so to make your own copy. </i></p>
            </div>
        </div>
    </div>
    <div class="modal-footer"><i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-success" (click)="generateDocument()" [disabled]="spinner == true" >Generate</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL GENERATE DOCUMENT-->


<!--START OF MODAL RATE FORM-->
<ng-template #modalRate>
    <div class="modal-header">
        <h6 class="modal-title">Edit Rate - <strong style="color: #007bff;">Total Cost: ${{ getFormTotalCost() }}</strong></h6>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    
    <form [formGroup]="rateForm" novalidate  (ngSubmit)="onSubmitRate(rateForm.value)">
        <div class="modal-body bg-gray">
            <div>Charge by: <strong><span *ngIf="connote.charging_method != 'Pallets'">{{connote.charging_method}}</span><span *ngIf="connote.charging_method == 'Pallets'">Freight Packaging</span></strong></div><br/>
            <div class="row">
                <div class="col-12">

                    <div class="row" *ngIf="connote.charging_method_id == 2">
                        <div class="form-group col-md-12">
                            <label class="form-control-label">Chargeable Pallets</label>
                            <input class="form-control" type="number" formControlName="pallet">
                        </div>
                    </div>    
                    <div class="row" *ngIf="connote.charging_method_id == 1">
                        <div class="form-group col-md-12">
                            <label class="form-control-label">Units in Tonnes</label>
                            <input class="form-control" type="number" formControlName="tonnes">
                        </div>
                    </div>   

                    <div class="row">
                        <div class="form-group col-md-12">
                            <label class="form-control-label">Price/Rate per Unit <span class="text-danger">*</span></label>
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend"><div class="input-group-text">$</div></div>

                                <input class="form-control" type="number" formControlName="price" min="0" (change)="checkIntValue($event,'price')">

                            </div>
                            <div *ngIf="rateForm.controls.price.touched">
                                <div *ngIf="rateForm.controls.price.errors?.required">
                                    <small class="text-danger">This field is required.</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col-md-12">
                        <label class="form-control-label">Fuel Levy</label>
                        <div class="input-group input-group-sm">
                            <div class="input-group-prepend"><div class="input-group-text">%</div></div>

                            <input class="form-control" type="number" formControlName="fuel_levy" min="0" max="100" (change)="checkIntValue($event,'fuel_levy')">

                        </div>
                            <div *ngIf="rateForm.controls.fuel_levy.touched">
                                <div *ngIf="rateForm.controls.fuel_levy.errors?.required">
                                    <small class="text-danger">This field is required.</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col-md-12">
                        <label class="form-control-label">Service Fee</label>
                        <div class="input-group input-group-sm">
                            <div class="input-group-prepend"><div class="input-group-text">%</div></div>

                            <input class="form-control" type="number" formControlName="service_fee" min="0" max="100" (change)="checkIntValue($event, 'service_fee')">

                        </div>
                            <div *ngIf="rateForm.controls.service_fee.touched">
                                <div *ngIf="rateForm.controls.service_fee.errors?.required">
                                    <small class="text-danger">This field is required.</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <h6>Additional Costs</h6>
                            <div formArrayName="connote_addins">
                                <div *ngFor="let addin of connoteAddins.controls; let i = index" [formGroupName]="i" class="mb-2">
                                    <div class="row">
                                        <div class="col-6">{{ addin.get('addin_label').value }}</div>
                                        <div class="col-3">
                                            <div class="input-group input-group-sm">
                                                <div class="input-group-prepend"><div class="input-group-text">$</div></div>
                                                <input type="number" class="form-control" formControlName="cost" [readonly]="addin.get('is_enabled').value == 0" min="0">
                                            </div>
                                        </div>
                                        <div class="col-3">
                                            <button type="button" class="btn btn-danger btn-sm" (click)="removeAddin(i)">Delete</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <select class="form-control" #addinSelect (change)="selectedAddin = $event.target.value">
                                        <option value="">Select Addin</option>
                                        <option *ngFor="let addin of availableAddins" [value]="addin.id">{{ addin.label }}</option>
                                    </select>
                                </div>
                                <div class="col-3">
                                    <div class="input-group input-group-sm">
                                        <div class="input-group-prepend"><div class="input-group-text">$</div></div>
                                        <input type="number" class="form-control" #costInput min="0" (input)="selectedCost = +$event.target.value">
                                    </div>
                                </div>
                                <div class="col-3">
                                    <button type="button" class="btn btn-primary btn-sm" [disabled]="!selectedAddin || selectedCost <= 0" (click)="addNewAddin(selectedAddin, selectedCost); selectedAddin=''; selectedCost=0; addinSelect.value=''; costInput.value=''">Add</button>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-12">
                                    <strong>Total Other Costs: ${{ getCurrentOtherCost().toFixed(2) }}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button type="submit" class="btn btn-sm btn-success" [disabled]="!rateForm.valid || spinner == true">Save
                Changes</button>&nbsp;
            <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
        </div>
    </form>
</ng-template>
<!--END OF MODAL RATE FORM-->

<!--START OF MODAL REFERENCE FORM-->
<ng-template #modalCustomer>
    <div class="modal-header">
        <h6 class="modal-title">Edit Customer Details</h6>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

        <div class="modal-body bg-gray">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Customer&nbsp;<i class="fa fa-spinner fa-spin" *ngIf="spinner2 == true"></i></label>
                        <select class="form-control form-control-sm" name="customer" [(ngModel)]="customer" [disabled]="spinner2 == true">
                        <option selected [ngValue]="null" disabled>Select</option>
                        <ng-container *ngFor="let item of customerslist">
                            <option [ngValue]="item.id" [ngClass]="{'font-italic': item.deleted_date != null}">{{item.name }}</option>
                        </ng-container>
                      </select>
                    </div>
                    <div class="form-group">
                        <label>Reference No.</label>
                        <input type="text" class="form-control" [(ngModel)]="reference_no" name="cust_ref_value" />
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button type="submit" class="btn btn-sm btn-success" [disabled]="spinner == true" (click)="updateCustomer()">Save Changes</button>&nbsp;
            <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
        </div>
</ng-template>
<!--END OF MODAL REFERENCE FORM-->

<!--START OF MODAL ACTIVITY FORM-->
<ng-template #modalActivity>
    <div class="modal-header">
        <h6 class="modal-title">Edit Activity Details   </h6>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <form [formGroup]="activityForm" novalidate>
        <div class="modal-body bg-gray">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Contact Name:</label>
                        <input type="text" class="form-control" formControlName="contact_name" name="contact_name" />
                    </div>
                    <div class="form-group">
                        <label>Contact #:</label>
                        <input type="number" class="form-control" formControlName="contact_no" name="contact_no" />
                    </div>
                    <div class="form-group">
                        <label>Contact Email:</label>
                        <input type="text" class="form-control" formControlName="contact_email" name="contact_email" />
                    </div>

                    <div class="form-group">
                        <label>Notes:</label>
                        <textarea type="text" class="form-control" formControlName="notes" name="notes"></textarea>
                    </div>
                </div>
            </div>
        </div>  
        
        <div class="modal-footer">
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button type="submit" class="btn btn-sm btn-success" [disabled]="spinner == true" (click)="onsubmitActivities(activityForm.value)">Save Changes</button>&nbsp;
            <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
        </div>
    </form>
</ng-template>
<!--END OF MODAL ACTIVITY FORM-->

<!--START OF TRANSVIRTUAL UPDATE MODAL-->
<ng-template #modelTVLogs>
    <div class="modal-header">
        <h6 class="modal-title">Transvirtual Log Information</h6>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div  class="modal-body">
        <span class="pb-1"><h6 class="mb-0">Request Type: {{logview.request_type.description}}</h6></span><br>
        <span class="pb-1"><h6 class="mb-0">Request Body: </h6></span><br>
        <div class="json-div">
            <pre>{{logview.request_body | json}}</pre>
        </div><br>

        <span class="pb-1"><h6 class="mb-0">Response Information: </h6></span><br>
        <div class="alert alert-dismissible fade show" [ngClass]="{'alert-success': logview.status_code == 200,  'alert-danger': logview.status_code != 200}" role="alert">
            <strong>{{logview.status_code}} {{logview.response_body?.StatusText}}</strong><br />
            <small>Request sent to <i> https://portal.transvirtual.com.au{{logview.request_path}}</i><br />
                Last update: {{logview.updated_at | date:'dd MMM yyyy h:mm a'}}&nbsp;
                (Attempts: {{(logview.request_type_id == 2)? logview.new_retry_times: logview.retry_times}})</small>
        </div>

        <span class="pb-1 mb-3">
            <small class="showText mb-0" style="cursor:pointer" (click)="showResponseJson()">
                {{(showResponse)?'Hide':'Show'}} Response JSON 
                <i class="fa" [ngClass]="(showResponse)? 'fa-angle-up':'fa-angle-down'" aria-hidden="true"></i>
            </small>
            <div class="json-div pb-3" *ngIf="showResponse">
                <pre style="padding: 2px;">{{logview.response_body | json}}</pre>
            </div>
        </span>
    </div>
    <div *ngIf="logview?.status_code != 200" class="modal-footer">
    
        <ng-container *ngIf="logview.retry_times > 3; else RetriesMax">
            <span class=" float-left pl-0">
                <small class="text-danger">*iDrv has reached the maximum number for attempts with failed response. Please contact iDrv or Transvirtual about this update issue.</small>

            </span>
        </ng-container>

        <ng-template #RetriesMax>
            <span class="float-right mt-2">
                <small *ngIf="!transvirtual_info.isActive" class="mr-auto"><i><span class="text-danger">Transvirtual updates are disabled.</span></i></small>
                <i class="fa fa-spinner fa-spin" *ngIf="retryClicked" ></i>&nbsp;
                <button class="btn btn-sm btn-danger" (click)="retryTransvirtualUpdate(logview)"
                [disabled]="!transvirtual_info.isActive || retryClicked"> Retry Update </button>&nbsp;
            </span>
          
        </ng-template>
        
    </div>
</ng-template>
<!--END OF TRANSVIRTUAL UPDATE MODAL-->